import React from 'react';

import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { Piwik, SiteCoreDictionary } from '../types';

import './ErrorReceipt.scss';

interface ReceiptProps {
    dictionary: SiteCoreDictionary;
    piwik: Piwik | undefined;
}

const Receipt = ({ dictionary, piwik }: ReceiptProps) => {
    const { processFailedTitle, blockFailedDescription } = dictionary;

    return (
        <div
            className="receipt-container"
            data-track-id={piwik?.orderNewCardForm?.orderCardSuccess?.dataTrackId}
            data-track-linkname={piwik?.orderNewCardForm?.orderCardSuccess?.dataTrackLinkname}
            id={piwik?.orderNewCardForm?.orderCardSuccess?.dataTrackId}
        >
            <div className="richicon-container">
                <RichIcon type={RichIconTypes.NETTVERKSBRUDD_HARE} />
            </div>
            <div className="error-title">{processFailedTitle}</div>
            <p>{blockFailedDescription}</p>
        </div>
    );
};

export default Receipt;
